export default __webpack_public_path__ + "static/media/homepage.9800c40d.png";